import React from "react";
import "./index.css";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= 5) {
      // Show all pages if totalPages is 5 or less
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Always show first, last, and current page with neighbors
      pages.push(1); // Always include the first page

      if (currentPage > 3) {
        pages.push("...");
      }

      const startPage = Math.max(currentPage - 1, 2);
      const endPage = Math.min(currentPage + 1, totalPages - 1);

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      if (currentPage < totalPages - 2) {
        pages.push("...");
      }

      pages.push(totalPages); // Always include the last page
    }

    return pages;
  };

  const renderPageNumbers = () => {
    return getPageNumbers().map((page, index) => {
      if (page === "...") {
        return (
          <span key={index} className="">
            ...
          </span>
        );
      }

      return (
        <button
          key={page}
          onClick={() => handlePageChange(page)}
          className={`button ${page === currentPage && "active-button"}`}
        >
          {page}
        </button>
      );
    });
  };

  // return (
  //   <div className="d-flex justify-content-center align-items-center ">
  //       <p className='page'>Page No: {currentPage}/{totalPages}</p>
  //       <button
  //           onClick={() => handlePageChange(currentPage - 1)}
  //           disabled={currentPage === 1}
  //           className="button"
  //       >
  //           {"<"} Prev
  //       </button>
  //       {renderPageNumbers()}
  //       <button
  //           onClick={() => handlePageChange(currentPage + 1)}
  //           disabled={currentPage === totalPages}
  //           className="button"
  //       >
  //           Next {">"}
  //       </button>
  //   </div>
  // )
  return (
    <div className="d-flex justify-content-center align-items-center ">
        {/* <p className='page'>Page No: {currentPage}/{totalPages}</p> */}
        <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="button"
        >
            {"<"} Prev
        </button>
        {renderPageNumbers()}
        <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="button"
        >
            Next {">"}
        </button>
    </div>
  );
};

export default Pagination;
